<script lang="ts" setup>
import { Card } from '@forgd/ui-kit/card'

const heroTitle = 'Launch & scale your token with\nconviction.'
const heroDescription = 'Tap on Forgd\'s self-service tools, expert advisors, and curated data from over 1500+\nblockchain projects to get the insights that matter. Free of charge.'
</script>

<template>
  <div class="divide-y divide-default">
    <div class="mx-auto flex w-full max-w-350 flex-col gap-6 px-4 pt-6 pb-10 md:px-5">
      <section class="grid grid-cols-1 gap-5 lg:grid-cols-3">
        <div class="flex flex-col gap-4 lg:col-span-2">
          <PrHeader
            id="hero"
            type="page"
            :title="heroTitle"
            title-class="text-base whitespace-pre-line md:text-xl md:whitespace-normal"
            description-class="md:whitespace-pre-line"
            :description="heroDescription"
          />
          <div id="summary-intelligence-cards" class="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <ClientOnly>
              <PrOverviewTokenomicsCard />
              <template #fallback>
                <Card class="h-60.5 sm:h-62.5 lg:h-66.5 xl:h-62.5" />
              </template>
            </ClientOnly>
            <ClientOnly>
              <PrOverviewExchangeListingsCard />
              <template #fallback>
                <Card class="h-60.5 sm:h-62.5 lg:h-66.5 xl:h-62.5" />
              </template>
            </ClientOnly>
            <ClientOnly>
              <PrOverviewMmLeaderboardSummaryCard id="mm-leaderboard-summary" class="sm:col-span-2" />
              <template #fallback>
                <Card id="mm-leaderboard-summary" class="h-80.5 sm:col-span-2 sm:h-51.25" />
              </template>
            </ClientOnly>
          </div>
        </div>
        <HomeExploreToolsPanel class="hidden lg:col-span-1 lg:flex" />
      </section>

      <CoreFullServiceAdvisoryBanner class="md:block" />

      <HomeHowToStart class="md:flex" />

      <hr class="my-2 border-default md:block">

      <ClientOnly>
        <PrUtrHomeBanner class="mb-4" />
        <template #fallback>
          <div class="mb-4 h-119.25 sm:h-78 lg:h-63.5 xl:h-59.75" />
        </template>
      </ClientOnly>

      <ClientOnly>
        <PrOverviewTokenomicsIntelligenceSection id="tokenomics-intelligence" />
        <template #fallback>
          <div id="tokenomics-intelligence" class="h-317.5 sm:h-220 lg:h-133.75 xl:h-120.25" />
        </template>
      </ClientOnly>
      <CoreTokenomicsPromoBanner class="mb-4" />

      <ClientOnly>
        <PrOverviewMmIntelligenceSection id="mm-intelligence" />
        <template #fallback>
          <div id="mm-intelligence" class="h-309.5 sm:h-304.75 md:h-307 lg:h-109.75 xl:h-109.5" />
        </template>
      </ClientOnly>
      <ClientOnly>
        <PrOverviewBestPerformersStrip />
        <template #fallback>
          <div class="h-78.75 sm:h-39.5 lg:h-20 xl:h-15.75" />
        </template>
      </ClientOnly>
      <CoreMarketMakerPromoBanner class="mb-4 md:block" />

      <ClientOnly>
        <PrOverviewExchangeIntelligenceSection id="exchange-intelligence" />
        <template #fallback>
          <div id="exchange-intelligence" class="h-577.75 sm:h-520 lg:h-255.5 xl:h-162" />
        </template>
      </ClientOnly>
      <CoreExchangePromoBanner
        crop-image-on-mobile
        image-class="object-cover object-center md:object-[right_-100%]"
        class="mb-4 md:block"
      />

      <ClientOnly>
        <PrOverviewMmMonitoringSection id="mm-monitoring" class="md:flex" />
        <template #fallback>
          <div id="mm-monitoring" class="h-448.75 sm:h-351.25 lg:h-199 xl:h-194" />
        </template>
      </ClientOnly>
      <CoreMonitoringPromoBanner class="mb-4 md:block" />

      <hr class="mb-4 border-default md:block">

      <CoreAcademyStrip />
    </div>

    <PrOverviewFaqSection class="mx-auto w-full max-w-350 px-4 md:px-10 md:pt-8 md:pb-12" />
  </div>
</template>
